import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../image/felt-teachers-logo.png';
import Hamburger from '../../Hamburger';
import Close from '../../Close';
import Icon from '../Icon';
import ApiContext from '../Context/ApiContext';

const Navbar = (props) => {
  let navbar = (
    <div>
      <nav className="navbar navbar-expand navbar-light bg-light scrolling-navbar fixed-top">
      <img className="logo" src={logo} alt="Softskills logo" />
  <a className="navbar-brand" href="/">JustCoded Softskills Solutions</a>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
    <span className="navbar-toggler-icon"></span>
  </button>

  <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
    <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
      <li className="nav-item active">
        <a className="nav-link" href="/">Home <span className="sr-only">(current)</span></a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="/contactus">Contact</a>
      </li>
        <li className="nav-item">
        <a className="nav-link" href="/signin">Login</a>
      </li>
    </ul>
     <span class="navbar-text">
     <a className="nav-link" href="/aboutus">About Us</a>
    </span>
  </div>
</nav>
    </div>
  );
  if (props.isLoggedIn) {
    navbar = (
      <div className="nav_flex" >{/*id={addClass()} */}
        <div className="logoImage">
          <NavLink className="link" to="/">
            <img className="logo" src={logo} alt="" />
          </NavLink>{' '}
        </div>

        <NavLink className="nav_link" activeClassName="current" to="/Signup">
          {props.signup ? <Icon classType="fas fa-sign-in-alt" /> : null} {props.signup}
        </NavLink>
      
        <NavLink className="nav_link" activeClassName="current" to="/signin">
          {props.signin}
        </NavLink>
        <NavLink
          className="nav_link"
          activeClassName="current"
          to="/"
          exact
          onClick={() => localStorage.removeItem('token')}
        >
          {props.signout ? <Icon classType="fas fa-sign-out-alt" /> : null} {props.signout}
        </NavLink>
        <NavLink className="nav_link" activeClassName="current" to="/dashboard">
          {`Hi, ${props.userName}`}
        </NavLink>
      </div>
    );
  }
  return (
    <nav>
      {/* <Hamburger click={toggleClass} /> */}
      {navbar}
      <ApiContext.Consumer>{
        context =>
          <Hamburger clicked={context.setSideDrawer}/>
          }
      </ApiContext.Consumer>
      <Close />
    </nav>
  );
};

export default Navbar;
